import { getToken, isTokenExpiredOrInvalid } from "./TokenUtil";
import { signInDetails } from "../pages/Login";

export const fetchWithAuthentication = async (
  route: string,
  method: string,
  data: any,
  isForm: boolean = false,
) => {
  if (isTokenExpiredOrInvalid()) {
    await refreshToken();
  }
  const token = getToken();
  let headers;
  let body;

  if (isForm) {
    headers = {
      Authorization: `Bearer ${token}`,
    };
    body = data;
  } else {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    body = JSON.stringify(data);
  }

  if (data !== null) {
    return await fetch("/admin_panel" + route, {
      method: method,
      headers: headers,
      body: body,
    });
  } else {
    return await fetch("/admin_panel" + route, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  }
};

export const refreshToken = async () => {
  const response = await fetch("/admin_panel/refresh", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (response.ok) {
    const data = await response.json();
    const { token, createdAt, expiresAt, username } = data;
    localStorage.setItem(
      "jwtToken",
      JSON.stringify({ token, createdAt, expiresAt, username }),
    );
    return token;
  } else if (isTokenExpiredOrInvalid()) {
    console.error("Failed to sign in:", response.status);
    throw new Error("Failed to refresh");
  }
};

export const login = async (signInDetails: signInDetails) => {
  // Returned value is { token, createdAt, expiresAt }
  return await fetch("/admin_panel/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(signInDetails),
  });
};

export const uploadFile = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetchWithAuthentication(
    "/chat/file",
    "POST",
    formData,
    true,
  );

  if (response.ok) {
    console.log("Upload successful");
    const json = await response.json();
    return json.hashS3Key;
  } else {
    console.error("Upload failed:", await response.text());
  }
};

export const fetchPresignedUrl = async (messageId: string) => {
  const response = await fetchWithAuthentication(
    `/chat/file?messageId=${messageId}`,
    "GET",
    null,
  );

  if (response.ok) {
    const json = await response.json();
    return json.presignedUrl;
  } else {
    console.error("Failed to fetch file:", await response.text());
  }
};

export const logout = async () => {
  const token = getToken();
  return await fetch("/admin_panel/logout", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
